/**
 * Component: Header Component
 * Header componnet used to show header in all page of this app.
 */

import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Container } from "react-bootstrap";
import cx from "classnames";
import PropTypes from "prop-types";
class Header extends React.Component {
  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    return (
      <header
        style={{ backgroundImage: `url(${this.props.headerImage})` }}
        className={cx("d-flex align-items-stretch", this.props.cname)}
      >
        <Container fluid className="container-default-space">
          <div
            className={cx(
              { "text-center text-uppercase": !this.props.scriptTitle },
              "position-relative h-100"
            )}
          >
            <span className="logo">
              <NavLink to="/">
                <img
                  src={this.props.settings.banner_images.ribbon_logo}
                  alt={
                    this.props.settings.providerName === "PLC-Sydney"
                      ? "Places Logo"
                      : "Connect Logo"
                  }
                  title={
                    this.props.settings.providerName === "PLC-Sydney"
                      ? "Places Logo"
                      : "Connect Logo"
                  }
                  className="img-fluid"
                />
              </NavLink>
            </span>
            {this.props.text ? (
              <div
                className={cx(
                  "place-text d-flex align-items-center wow fadeInLeft h-100",
                  {
                    "justify-content-start": this.props.scriptTitle,
                    "justify-content-center": !this.props.scriptTitle,
                  }
                )}
              >
                {this.props.scriptTitle ? (
                  <h1 className="page-title">{this.props.text}</h1>
                ) : (
                  <strong>
                    <i>{this.props.text}</i>
                  </strong>
                )}
              </div>
            ) : (
              <div
                style={{ backgroundImage: `url(${this.props.bgImage})` }}
                className="place-logo wow fadeInLeft h-100"
              />
            )}
          </div>
        </Container>
      </header>
    );
  }
}

Header.propTypes = {
  scriptTitle: PropTypes.bool,
};

Header.defaultProps = {
  scriptTitle: false,
};

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */

function mapStateToProps(state, props) {
  return {
    user: state.user.user,
    settings: state.user.user
      ? state.settings.byId[state.user.user.schoolUid]
      : "",
  };
}
/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps)(Header);
